export default __webpack_public_path__ + "static/media/simple_process_bg.edd9bc4b.png";